import React from "react"

const minautee_dighe = () => {
    return (
        <div>
<h1>Minautee Dighe</h1>

<h4><em>Computer Engineering, Batch of 27'<br/><hr/></em></h4>

<p><strong>What was the criteria for shortlisting candidates in the initial stages of the recruitment process</strong>?</p>

<ol>
<li>Online Aptitude Test  </li>
<li>Offline interviews  
<ol>
<li>Technical Round  </li>
<li>HR Round</li>
</ol></li>
</ol>

<p><strong>What was the Timeline of the entire Interview Process</strong>?<br />
The entire process lasted less than a week, results from the aptitude round came out on 25th July and we had about three days to prepare for the interview which was on 28th July.<br />
Results from the interview thankfully came out on the same day, which made the experience nerve-wracking but a short-lived ordeal.</p>

<p><strong>What was the Structure of the Aptitude Round?</strong><br />
We had 2 coding questions that differed for every student, one of which was moderate, and the other one was tougher. I had mine on dynamic programming and graphs.<br />
There were few questions on SQL, OOPS, and OS.<br />
The thing that differed in Hilti’s apti was that there was a speaking section as well.You get under thirty seconds to read the question after which they start recording; you only get one shot at this. They try to gauge how well you perform when put on the spot and your articulation skills.</p>

<p><strong>How many students were shortlisted after the Aptitude Round?</strong><br />
We had around 28 students selected after the aptitude round.</p>

<p><strong>After being shortlisted, how long was the wait time before the interviews began? During this period, what specific areas did you focus on to prepare effectively?</strong><br />
We had roughly three days between results and interviews;<br />
Two major things I focussed on were:<br />
 1) I read up a lot about the company, went through their website and understood the various kind of services they provided, I also had a rough idea about input I could offer in each of these programs, this came in handy during the interview and I do believe it gave me a bit of an edge during the technical round.<br />
2) I did a thorough run through of my resume, went word by word and revised all my mentioned skills,I also gave my projects a solid once over since it had been a long time since I had completed some of them like my DSA project.<br />
I also briefly revised DBMS, OOPS through one shots and practised basic DSA concepts.</p>

<p><strong>How many Interview Rounds were there for the company, can you elaborate about each round in brief? Also mention, how many students were shortlisted after each Interview Round?</strong></p>

<p>We had two interview rounds (technical and HR).<br />
Twelve students were selected after the technical round.</p>

<p>Technical Round:<br />
I was asked to write pseudocode to find duplicate numbers in an array using only one pass.<br />
There was another DSA question on trees.</p>

<p>If you are stuck, do talk to them through your approach and ask them specific questions, generally they will help you out.<br />
I was also asked a few SQL queries, basic DBMS questions, and OOPS concepts.<br />
They also described a project and asked whether I would prefer to use React or Angular for said project and the strengths of doing so.</p>

<p>We ended the round by chatting about one of their services from a non-technical perspective.<br />
The technical interview lasted for little over an hour.</p>

<p>HR Round:<br />
The HR round was comparatively shorter;<br />
I was asked about my favourite subject in college, and I answered honestly that it wasn’t one from my degree but rather my minor, Industrial Psychology.<br />
Then I was asked what aspects of Industrial Psychology I had seen incorporated in my previous internship and what could have been improved.<br />
There were a few behavioural and general questions about how I would handle specific situations.<br />
He also asked about the extracurriculars I pursued in college. We talked extensively about my experience in debating and with the debate society.<br />
Since I’m originally from Mumbai, he asked about cultural differences I noticed after living in Pune for three years, and we also lightly dissed the Mumbai local trains :)</p>

<p>At the end, I asked him for feedback and what one area I could improve on. He mentioned that my projects didn’t fully align with their work. I explained that there was still a full year before the internship, during which I’d be picking up more relevant skills. He seemed satisfied with that, and I was glad I asked it since it allowed me to present my reasoning clearly.</p>

<p><strong>Some tips to crack Coding Questions?</strong><br />
If you are solving Leetcode especially during the sy summer break, do not solve 20 questions of the same pattern with minor variations, try to solve a diverse range of questions.<br />
Do not spend more than a day or two on a singular Leetcode question, there are some questions that don’t click unless you know the underlying trick, but once you do see the answer focus on <em>why</em> each step works.<br />
I made a horrible mistake in my second year when I solved Leetcode questions in C, since that’s what we were taught DSA in, that unnecessarily slowed me down, I could have solved a lot more questions if I had switched to Java early on.<br />
Be consistent with Leetcode, since after every prolonged break you feel like you’re starting back from scratch</p>

<p><strong>Any Final Tips for Juniors?</strong><br />
Spend time on your resume and draft it well and don’t worry if your resume doesn’t appear as stacked as others but do not make up stuff to lengthen it.<br />
How you come across in the interview is as important as your technical know-how, be confident without being arrogant; appear open and eager to learn.<br />
It is a pretty stressful period, be kind to yourself throughout this, you’ve got this :) </p>

<p><strong>Contact Info</strong><br />
<strong>Email :</strong> <a href="mailto:minauteedighe@gmail.com">minauteedighe@gmail.com</a><br />
<strong>LinkedIn :</strong><a href="https://www.linkedin.com/in/minautee-dighe"> Minautee Dighe</a></p>


<hr />

        </div>
    )
}

export default minautee_dighe
